import React from 'react';
import '../Cards/Cards.css';
import './ServicesPage.css';
import CardItem from '../Cards/CardItem';
import {useTranslation} from "react-i18next";

function ServicesPage() {
    const { t } = useTranslation();

    return (
        <div className='cards'>
            <h1>{t("Services")}</h1>
            <div className='cards__container'>
                <div className='cards__wrapper'>
                    <ul className='cards__items'>
                        <CardItem
                            src='images/olikesAnakainiseis/VPR02628_Vasso_Paraschi.webp'
                            text={t("Complete Renovations")}
                            path='/services/complete-renovations'
                            legend
                        />
                        <CardItem
                            src='images/eidikesKataskeves/VPR02781_Vasso_Paraschi.webp'
                            text={t("Special Constructions")}
                            path='/services/special-constructions'
                            legend
                        />
                        <CardItem
                            src='images/bedrooms/VPR02723_Vasso_Paraschi.webp'
                            text={t("Bedrooms")}
                            path='/services/bedrooms'
                            legend
                        />
                        <CardItem
                            src='images/patoma/VPR02883_Vasso_Paraschi.webp'
                            text={t("Flooring")}
                            path='/services/floor'
                            legend
                        />
                        <CardItem
                            src='images/mpanio/VPR02476_Vasso_Paraschi.webp'
                            text={t("Bathrooms")}
                            path='/services/bathrooms'
                            legend
                        />
                    </ul>
                    <ul className='cards__items'>
                        <CardItem
                            src='images/kouzina/VPR02547_Vasso_Paraschi.webp'
                            text={t("Kitchens")}
                            path='/services/kitchens'
                            legend
                        />
                        <CardItem
                            src='images/saloni/VPR03431_Vasso_Paraschi.webp'
                            text={t("Living Rooms")}
                            path='/services/living-rooms'
                            legend
                        />
                        <CardItem
                            src='images/fotismos/VPR02872_Vasso_Paraschi.webp'
                            text={t("Lighting")}
                            path='/services/lighting'
                            legend
                        />
                        <CardItem
                            src='images/alouminia/VPR03226_Vasso_Paraschi.webp'
                            text={t("Aluminum Frames")}
                            path='/services/aluminum-frames'
                            legend
                        />
                        <CardItem
                            src='images/smartHome/VPR03195_Vasso_Paraschi.webp'
                            text={t("Smart Home")}
                            path='/services/smart-home'
                            legend
                        />
                    </ul>
                    <ul className='cards__items'>
                        <CardItem
                            src='images/exoterikoiHoroi/VPR02672_Vasso_Paraschi.webp'
                            text={t("Exterior Spaces")}
                            path='/services/exterior-spaces'
                            legend
                        />
                        <CardItem
                            src=''
                            text=''
                            path=''
                            extraClassName='placeholder'
                        />
                        <CardItem
                            src=''
                            text=''
                            path=''
                            extraClassName='placeholder'
                        />
                        <CardItem
                            src=''
                            text=''
                            path=''
                            extraClassName='placeholder'
                        />
                        <CardItem
                            src=''
                            text=''
                            path=''
                            extraClassName='placeholder'
                        />
                    </ul>
                </div>
            </div>
        </div>
    )
        ;
}

export default ServicesPage;
